export const SHOWN_OBJECT_IDS = [6, 4, 1, 2, 3, 9, 10];
